import { useState } from 'react'
import { useTagsMutations } from '../../../../hooks/templates/tags/useTags'
import styles from './Tags.section.module.css'
import { Plus, X } from 'lucide-react'
import type { GetTagsOutput } from '@montatec/contracts'

type Props = {
    tags: GetTagsOutput | undefined
    selectedCategoryId: number | null
    selectedTagId: number | null
    setSelectedTagId: (id: number | null) => void
    findTagBase: () => number | null
}

export default function TagsSection({tags, selectedCategoryId, selectedTagId, findTagBase, setSelectedTagId}: Props) {      
    const {createTag, deleteTag } = useTagsMutations()    

    const [isOpenAddTag, setOpenAddTag] = useState(false)
    const [tagInput, setTagInput] = useState("")

    const handleDeleteTag = (tagId: number) => {
        if(!selectedCategoryId) return

        deleteTag.mutate({
            categoryId: selectedCategoryId,
            tagId
        })
    }
    
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if(e.code === "Enter") {            
            createTag.mutate({
                categoryId: selectedCategoryId!,
                data: { name: tagInput.trim()}
            })
            
            setOpenAddTag(false)
            setTagInput("")
        }
    }    
    
    return (
        <div className={styles.section}>
            <span className={styles.title}>Etiquetas</span>        
            <div className={styles.tags}>  
                
                { isOpenAddTag ? 
                    <div className={`${styles.tag} ${styles.add}`}
                        onKeyDown={handleKeyDown}
                    >
                        <input 
                            onBlur={() => setOpenAddTag(false)} 
                            autoFocus={true} type="text" 
                            value={tagInput}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTagInput(e.currentTarget.value)}  
                        />                        
                    </div>
                :
                    <div className={`${styles.tag} ${styles.add}`}
                        onClick={() => setOpenAddTag(true)}
                    >
                        <Plus />
                    </div>
                }
                {
                tags?.map(tag => ( !tag.isBase &&             
                    <div 
                        key={`tag-${tag.id}`} 
                        className={`${styles.tag} ${selectedTagId === tag.id ? styles.active : ""}`}
                        onClick={() => setSelectedTagId(selectedTagId === tag.id ? findTagBase() : tag.id)}
                    >
                        <span>{tag.name}</span>
                        <X className={styles.delete} onClick={() => handleDeleteTag(tag.id)}/>
                    </div>
                ))
                }          
            </div>  
        </div>                  
              
  )
}
